import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a1dfa42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_4 = { class: "submit-btn" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onActivated, onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { saveProjectStop } from '@/apis/projectTermination'
import dayjs from 'dayjs'
import { Toast } from 'vant'
import { ApproveConfig, CarboncopyConfig } from '@/apis/public/oauth'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const state = reactive({
  formData: {
    project_id: null,
    project_name: '',
    explain: null
  }
})

const onSubmit = async () => {
  console.log('onSubmit', state.formData)

  const res = await saveProjectStop({ ...state.formData })
  if (res.code == 200) {
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}

const onFailed = errorInfo => {
  console.log('failed', errorInfo)
}
const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})

const review_carbon = ref({
  review: [],
  carbon: []
})

const get_approve_config = async () => {
  let typeId = {
    type: 2
  }
  const res = await ApproveConfig(typeId)
  const res1 = await CarboncopyConfig(typeId)
  if (res.code === 200) {
    if (res.data) {
      res.data.forEach(e => {
        review_carbon.value.review.push(e.staff)
      })
    }
  }
  if (res1.code === 200) {
    if (res1.data) {
      res1.data.forEach(e => {
        review_carbon.value.carbon.push(e.staff)
      })
    }
  }
}
onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  state.formData.project_id = router.currentRoute.value.query.project_id.toString()
  state.formData.project_name = router.currentRoute.value.query.project_name.toString()
  get_approve_config()
})

onActivated(() => {})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_review_people = _resolveComponent("review-people")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, {
      class: "form",
      onSubmit: onSubmit,
      onFailed: onFailed,
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "项目名称",
              value: _unref(state).formData.project_name
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_field, {
          "input-align": "left",
          modelValue: _unref(state).formData.explain,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).formData.explain) = $event)),
          required: "",
          class: "content",
          name: "explain",
          label: "终止原因",
          type: "textarea",
          placeholder: "请输入",
          rows: "5"
        }, null, 8, ["modelValue"]),
        _hoisted_2,
        _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
        _hoisted_3,
        _createVNode(_component_review_people, { review_carbon: review_carbon.value }, null, 8, ["review_carbon"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_bottom_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})